import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { SortOptionsForType } from '../../../ts/models/sort/SortOptionDefinitions';

export const WorkbookSubspaceDatasourcesSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'refresh': SortOptions.datasourceRefresh,
    'alert': SortOptions.alert
  },
  displaySortDropdown: true
};

export const WorkbookSubspaceViewsSortOptions: SortOptionsForType = {
  defaultOrder: [Order.asc(OrderKeys.index), Order.asc(OrderKeys.name)],
  options: {
    'name': SortOptions.name,
    'hits': SortOptions.hits,
    'sheet': SortOptions.sheetIndex,
  },
  displaySortDropdown: true
};
